import { render } from "./FormComponent.vue?vue&type=template&id=403b3fc1&scoped=true"
import script from "./FormComponent.vue?vue&type=script&lang=js"
export * from "./FormComponent.vue?vue&type=script&lang=js"

import "./FormComponent.vue?vue&type=style&index=0&id=403b3fc1&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\veron\\PhpstormProjects\\wingo\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-403b3fc1"]])

export default __exports__